
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guidebook/summary/parlor",
      function () {
        return require("private-next-pages/guidebook/summary/parlor.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guidebook/summary/parlor"])
      });
    }
  